'use strict';

var _classCallCheck = require("/home/nftfrontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/nftfrontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/nftfrontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/home/nftfrontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/nftfrontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var pump = require('pump');

var tar = require('tar-stream');

var ReadableStream = require('readable-stream').Readable;

var ObjectsStreams = /*#__PURE__*/function (_ReadableStream) {
  _inherits(ObjectsStreams, _ReadableStream);

  var _super = _createSuper(ObjectsStreams);

  function ObjectsStreams(options) {
    _classCallCheck(this, ObjectsStreams);

    var opts = Object.assign(options || {}, {
      objectMode: true
    });
    return _super.call(this, opts);
  }

  _createClass(ObjectsStreams, [{
    key: "_read",
    value: function _read() {}
  }]);

  return ObjectsStreams;
}(ReadableStream);
/*
  Transform a tar stream into a stream of objects:

  Output format:
  { path: 'string', content: Stream<Readable> }
*/


var TarStreamToObjects = function TarStreamToObjects(inputStream, callback) {
  var outputStream = new ObjectsStreams();
  var extractStream = tar.extract();
  extractStream.on('entry', function (header, stream, next) {
    stream.on('end', next);

    if (header.type !== 'directory') {
      outputStream.push({
        path: header.name,
        content: stream
      });
    } else {
      outputStream.push({
        path: header.name
      });
      stream.resume();
    }
  }).on('finish', function () {
    return outputStream.push(null);
  });
  pump(inputStream, extractStream);
  callback(null, outputStream);
};

module.exports = TarStreamToObjects;